import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import ChangeLocationService from '../../../../services/ChangeLocationService';
import { translate, formatData, isNullOrEmpty, closeCollapsible } from '../../../../utils/util';
import { BackButton, Title, Subtitle, Button, ListPaginationNew, ScannerCode, SelectItem, Collapsible } from '../../../../components/UI/ComponentsUI';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import { setSelectedLog } from '../../../../actions/logAction';
import M from 'materialize-css/dist/js/materialize';
import Select from '../../../../components/UI/Select';
import InputUI from '../../../../components/UI/InputUI';

const LogTransmission = (props) => {
    const initialValues = {
        entrance: null,
        errorMessage: null,
        dateStart: null,
        dateEnd: null,
        createdby: null,
        partnumber: null,
        success: false
    }

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [filterSearch, setFilterSearch] = useState(initialValues)
    const [orderDirection, setOrderDirection] = useState("ASC")

    useEffect(() => {
        setData([]);
        setTotalPages(0);
        setCurrentPage(0);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage, orderDirection]);

    const onSearch = (refreshing) => {
        props.getTransmissions({
            ...filterSearch,
            OrderDirection: orderDirection,
            PageSize: 30,
            PageIndex: currentPage
        }, (c) => {
            let list = [];
            Object.assign(list, data);
            refreshing ? list = c.items : list.push(...c.items)
            setData(list);
            setTotalPages(c.totalPages);
            closeCollapsible('collapsible');
        });
    }

    const scanner = (value) => {
        if (!isNullOrEmpty(value)) {
            setFilterSearch({ ...filterSearch, createdby: value });

            const inputusername = document.getElementById('userName');
            if (inputusername) {
                inputusername.value = value;
                inputusername.focus();
            }
            M.updateTextFields();
        }
    };

    const onChange = (event) => {
        onValueChange(event, filterSearch, setFilterSearch);
    };

    const onChangeUserName = (event) => {
        setFilterSearch({ ...filterSearch, createdby: event });
    }

    const onClick = () => {
        setData([])
        setCurrentPage(0);
        onSearch(true)
    }

    const onItemClick = (item) => {
        props.setSelectedLog(item);
        props.history.push({
            pathname: `logtransmissiondetail`,
            state: { change: item }
        });
    }

    const updateOrder = (type) => {
        window.scrollTo(0, 0)
        let newOrder = orderDirection === "ASC" ? "DESC" : "ASC";
        setOrderDirection(newOrder)
        setData([])
        setCurrentPage(0);
    }

    return (
        <div>
            <BackButton {...props} />
            <Title icon="mdi mdi-clipboard-list-outline" label={translate('exchange-location', 'menu')} />
            <Subtitle icon="mdi mdi-clipboard-list-outline" label={translate('log-transmission-title', 'change-location')} />

            <div className="container-fluid" style={{ paddingTop: '2px' }}>
                <div className="container" >
                    <Collapsible
                        id="collapsible"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" >
                                    <div className="row">
                                        <div className="input-field no-padding col s5">
                                            <InputUI
                                                defaultValue={filterSearch.dateStart}
                                                type="date"
                                                label={translate('change-location:startDate')}
                                                id="dateStart"
                                                name="dateStart"
                                                onChange={onChange}
                                                required={!isNullOrEmpty(filterSearch.dateEnd)}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s6">
                                            <InputUI
                                                defaultValue={filterSearch.dateEnd}
                                                type="date"
                                                label={translate('change-location:endDate')}
                                                id="dateEnd"
                                                name="dateEnd"
                                                onChange={onChange}
                                                required={!isNullOrEmpty(filterSearch.dateStart)}
                                            />
                                        </div>
                                        <div className="input-field no-padding no-margin-top col s5">
                                            <InputUI
                                                id="cim"
                                                name="cim"
                                                label={translate('cim', 'change-location')}
                                                type="text"
                                                maxLength={10}
                                                defaultValue={filterSearch.entrance}
                                                onChange={onChange}
                                                onBlur={onChange}
                                            />
                                        </div>
                                        <div className="input-field no-padding no-margin-top col s6">
                                            <InputUI
                                                id="partnumber"
                                                name="partnumber"
                                                label={translate('partnumber', 'change-location')}
                                                type="text"
                                                maxLength={11}
                                                defaultValue={filterSearch.partnumber}
                                                onChange={onChange}
                                                onBlur={onChange}
                                            />
                                        </div>

                                        <div className="input-field no-padding no-margin-top col s5">
                                            <ScannerCode className={"mdi mdi-qrcode posfix"} onScanner={scanner} />
                                            <SelectItem
                                                id="createdby"
                                                name="createdby"
                                                value={filterSearch.createdby}
                                                onChange={(event) => onChangeUserName(event)}
                                                onChangeData={onChangeUserName}
                                                data={props.usersFromElog ? props.usersFromElog.map(item => {
                                                    return {
                                                        id: item.id,
                                                        text: item.user
                                                    }
                                                }) : []}
                                            />
                                            <label className="required" htmlFor="username">{translate('login.username')}</label>
                                        </div>
                                        <div className="input-field no-padding no-margin-top col s6" style={{ marginTop: 0, marginBottom: 0 }}>
                                            <Select
                                                id="success"
                                                name="success"
                                                display="description"
                                                defaultValue={filterSearch.success}
                                                data={[{ id: true, text: translate('change-location:success'), }, { id: false, text: translate('change-location:fail') }]}
                                                change={onChange}
                                                placeHolder={`Status - ${translate('general:SelectAll')}`}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ marginBottom: '5px' }}>
                                    <Button full="true" onClick={() => onClick()} text={translate('search', 'general')} />
                                </div>
                            </>
                        }
                    />
                    {data.length > 0 &&
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div onClick={() => updateOrder()} className="sixth-text-color flex-center" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} >
                                <i className={`mdi mdi-menu-${orderDirection === "ASC" ? 'up' : 'down'} f24`} />
                                <b>{translate('order', 'general')}</b>
                            </div>
                        </div>
                    }
                    <ListPaginationNew
                        page={totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={data.map((item, index) => {
                            return (
                                <div
                                    style={{ display: 'block', padding: '10px', height: 'auto' }}
                                    key={`oi-${index}`}
                                >
                                    <div onClick={() => onItemClick(item)}>
                                        <span className="sixth-text-color" style={{ display: 'block' }}>{item.partNumber}</span>
                                        <b className="sixth-text-color" style={{ display: 'block' }}>{item.cim} - {item.location}{(!isNullOrEmpty(item.cimQuantity) && item.cimQuantity > 0) ? ` - ${translate('cim-quantity', 'change-location')}: ${item.cimQuantity}` : ''}</b>
                                        <i className="sixth-text-color" style={{ display: 'block' }}>{item.message}</i>
                                        <span className="sixth-text-color" style={{ display: 'block' }}>{item.fileName?.fileName ?? ""}</span>
                                        <b className="sixth-text-color">{item.uploadFile ? translate('change-location:uploadLabel') : translate('change-location:createdBy')}</b>
                                        <span className="sixth-text-color">{item.createdByDesc} | {formatData(item.createdOn)}</span><br />
                                        <b className="sixth-text-color">{translate('change-location:updatedBy')}</b>
                                        <span className="sixth-text-color">{item.updatedByDesc} | {formatData(item.updatedOn)}</span><br />
                                    </div>
                                    <span className="sixth-text-color right" style={{ marginTop: '-20px' }}>
                                        {index + 1}
                                    </span>
                                </div>
                            );
                        })}
                    />
                </div>
            </div>
        </div>
    );
}


// Montar uma lista para dropdown com os usuarios do sistema
const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTransmissions: (filter, callback) => {
            dispatch(ChangeLocationService.getTransmissions(filter, callback));
        },
        setSelectedLog: (log) => {
            dispatch(setSelectedLog(log));
        },
        getInfo: (filter, callback) => {
            dispatch(ChangeLocationService.getInfo(filter, callback));
        },
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogTransmission)));

